import { Drawer } from 'antd';
import type { ReactNode } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}
const AdminNavigationDrawer = ({ open, onClose, children }: Props) => (
  <Drawer title="Administração" placement="left" open={open} onClose={onClose}>
    {children}
  </Drawer>
);
export default AdminNavigationDrawer;
